import React from 'react';
import SimpleFooter from './views/examples/components/Footers/SimpleFooter';
import circles from "./Circles-amico.svg"
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardImg,
  FormGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col
} from "reactstrap";
import logo from "./CircleRoundTable.png"
import ReactPlayer from "react-player"

const About = () => (
  <div className='about' style={{ backgroundColor: 'white', height: '95vh' }}>
    <div className='container' style={{ paddingTop: '70px' }}>
      <br />
      <h1 className="display-2 text-black" style={{
        background: '-webkit-linear-gradient(top right,  #6EA59A, #867fd7)',
        webkitBackgroundClip: 'text',
        webkitTextFillColor: 'transparent',
        // fontWeight:'bold',
        // fontFamily:'helvetica',
        fontSize: '50px'
      }}>
        What is RoundTable?</h1>
      {/* <section className="section section-lg" style={{ backgroundColor: "#fcf5f9", width: "80vw", borderRadius: "10px", margin: "0 0 10px 0" }}> */}
      <p>RoundTable is an online tool that allows groups and associations to make decisions, vote, and communicate in a streamlined and secure way. We do so with our underlying technology of smart contracts, which enable groups to interact and transact while remaining decentralized and autonomous. Our initial target customers are angel investing associations.</p>
      {/* </section> */}
      <div style={{margin:'40px'}}>
      <ReactPlayer
            url={"https://www.youtube.com/watch?v=BZWip_IoL9A"}
            // poster={logo}
            width="1000px"
            height="500px"
          // primaryColor="red"
          // other props
          />
          </div>
      <h1 className="display-2 text-black" style={{
        background: '-webkit-linear-gradient(top right, #6EA59A, #867fd7)',
        webkitBackgroundClip: 'text',
        webkitTextFillColor: 'transparent',
        // fontWeight:'bold',
        // fontFamily:'helvetica',
        fontSize: '50px'
      }}>What is a Circle?</h1>
      <Row>
        <Col>
          <section className="section section-lg" style={{ width: "50vw", borderRadius: "10px", margin: "0 0 10px 0" }}>
            <p>The central feature of RoundTable’s platform is the ability to create what we call Circles. Serving as the hub around which your angel investing association can form, Circles allow you and your group members to execute a number of versatile capabilities, including creating proposals, voting on proposals, making and joining new Circles within existing ones, and more.</p>
            <p>Our Circles function on the blockchain, meaning that they are effectively DAOs, or “decentralized autonomous organizations.” This is the unique value of RoundTable to its users: because every decision made is stored on the blockchain, they are transparently accessible to anybody at any time. Moreover, these decisions are verifiably secure in a distinctive way unparalleled by any existing platform, which is crucial for any angel investor dealing with early-stage transactions and investments.
              Underlying any DAO is its corresponding smart contract, which determines how the organization is operated and how it is governed. The smart contract is itself contained on a blockchain network, thus eliminating the need for a centralized authority that executes transactions between parties (especially when they are less familiar with each other).</p>
          </section>
        </Col>
        <Col>
          <img src={circles} />
        </Col>
      </Row>
      <h1 className="display-2 text-black" style={{
        background: '-webkit-linear-gradient(top right, #6EA59A, #867fd7)',
        webkitBackgroundClip: 'text',
        webkitTextFillColor: 'transparent',
        // fontWeight:'bold',
        // fontFamily:'helvetica',
        fontSize: '50px'
      }}>Why RoundTable?</h1>
      <Row>
        <Col>
          <img src={logo} width="350px"/>
        </Col>
        <Col>
          <section style={{width:"700px"}}>
            <p>We’ve been working with angel investors, learning about both their startup-evaluating expertise and also the pain points, challenges, and issues they’ve encountered on the day-to-day. For these organizations, some of the greatest irritations come in the form of cohesive collaboration and member engagement: the most painfully manual time investment for many, we’ve found, takes place after SPVs are created and money is committed to deals, when administrators need to take weeks and months committing investors to signing files and setting up rounds.</p>
            <p>Other problems abound as well: for funds, associations need an effective voting tool to determine who moves on in startup competitions and receives funding; for groups more conventionally, administrators need a way to identify when deals are taking place, which startups are funded, and how much they’re receiving so that they can grow their organization and increase entrepreneurship interest.</p>
            <p>Using RoundTable, the organizational challenges of an angel investing association become positively easy. Join a Circle with your fellow member entrepreneurs. When you want to form a syndicate with just a few, you can make a smaller Circle with them, visible to your peers in case they’d like to hop in. When you’d like to make a decision, you can introduce a proposal to the rest of your circle with the click of a button and a few keystrokes.</p>
            <br /><br />
          </section>
        </Col>
      </Row>
    </div>
    <SimpleFooter></SimpleFooter>
  </div >
);

export default About;